import { render, staticRenderFns } from "./IndicatorSmall.vue?vue&type=template&id=bfda02a6"
import script from "./IndicatorSmall.vue?vue&type=script&lang=js"
export * from "./IndicatorSmall.vue?vue&type=script&lang=js"
import style0 from "./IndicatorSmall.vue?vue&type=style&index=0&id=bfda02a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports